/* eslint-disable */
const cloudbaseConfig = require('../../cloudbaserc')

export const config = {
  envId: cloudbaseConfig.envId,
  storageBaseUrl: ''
}
